import SchedulingExtendModule from './containers/schedulingExtendModule'

export {default as SchedulingExtendModuleLayout} from './components/schedulingExtendModuleLayout'

export default SchedulingExtendModule
